/**
 * @flow
 * @format
 */

import _ChartLineGraph from './ChartLineGraph';

export default _ChartLineGraph;



// WEBPACK FOOTER //
// ./src/components/ChartLineGraph/index.js